// extracted by mini-css-extract-plugin
module.exports =  {"chartAxisG":"MultiLineChartAxes-module__chartAxisG--p6po5"};